import script from "./LoginAlert.vue?vue&type=script&lang=js"
export * from "./LoginAlert.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__